import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function PwaStartRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    let installedSlug = null;

    try {
      installedSlug = localStorage.getItem("smartbusinessInstalledSlug");
    } catch {
      installedSlug = null;
    }

    if (!installedSlug || installedSlug === "__HOME__") {
      navigate("/", { replace: true });
      return;
    }

    navigate(`/${installedSlug}`, { replace: true });
  }, [navigate]);

  return null;
}